export default __webpack_public_path__ + "static/media/front.c9dc4183.png";